import React from "react";
import { useNavigate } from "react-router-dom";
import Button, { buttonClasses } from "./button";
import { VariantProps, cva } from "class-variance-authority";

interface BackButtonProps extends VariantProps<typeof buttonClasses> {
    className?: string;
    onClick?: () => void;
}

export default function BackButton({ className, variant, size = "box", onClick }: BackButtonProps) {
    const navigate = useNavigate();
    return (
        <Button variant={variant} size={size} className={className} onClick={() => (onClick ? onClick() : navigate(-1))}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
            </svg>
        </Button>
    );
}
